/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const DeviceLaptopStar24Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 24, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="DeviceLaptopStar24Icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <path
              d="M18 11H19V8.366L21.2811 9.68301L21.7811 8.81699L19.5 7.49999L21.7811 6.18301L21.2811 5.31699L19 6.63399V4H18V6.63395L15.719 5.31699L15.219 6.18301L17.5 7.49999L15.2189 8.81699L15.7189 9.68301L18 8.36604V11Z"
              fill="currentColor"
            />
            <path
              d="M5.5 6H14V7H5.5C5.22386 7 5 7.22386 5 7.5V17H19V12H20V17L23 17.0273V18.0273H1V17.0273L4 17V7.5C4 6.67157 4.67157 6 5.5 6Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

DeviceLaptopStar24Icon.tags = [
  'laptop',
  'breakpoint',
  'star',
  'device',
  'favorite',
  'online',
  'rating',
];

DeviceLaptopStar24Icon.category = '24x24';

DeviceLaptopStar24Icon.iconSize = 24;
